import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }

import { computed } from 'vue';
import { format, parseISO } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarDay',
  props: {
    baseDate: {},
    events: {},
    title: {},
    moduleName: {},
    onCreate: { type: Function },
    calendarConfig: {}
  },
  setup(__props: any) {

const props = __props;

const formattedDate = computed(() => format(props.baseDate, 'eeee dd MMMM yyyy'));
const formatTime = (datetime: string) => format(new Date(datetime), 'HH:mm');

function normalizeDate(input: string): string {
  const date = parseISO(input);
  return format(date, 'yyyy-MM-dd');
}

const sortedEvents = computed(() => {
  const dateStr = format(props.baseDate, 'yyyy-MM-dd');
  return props.events
    .filter(e => normalizeDate(e.original?.[props.calendarConfig.dateField]) === dateStr)
    .sort((a, b) => new Date(a.original?.[props.calendarConfig.dateField]).getTime() - new Date(b.original?.[props.calendarConfig.dateField]).getTime());
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_1, _toDisplayString(formattedDate.value), 1),
                  _createVNode(_component_v_timeline, { dense: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEvents.value, (event) => {
                        return (_openBlock(), _createBlock(_component_v_timeline_item, {
                          key: event.id,
                          color: event.color || 'primary',
                          small: ""
                        }, {
                          opposite: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formatTime(event.date)), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(event.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})